import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {FormItemComponentInterface} from '../../../../interface/component';
import {HttpFormDataService} from '../../../../services/services';
import {IHttpReturnParam, IHttpSetting} from '../../../../interface/dataset-params';
import {GlobalObjectService} from '../../../../class/global-obj';
import {FormEventService} from '../../../../services/formEventService';

@Component({
    selector: 'noos-dataset',
    templateUrl: './dataset.component.html',
    styleUrls: ['./dataset.component.scss']
})
@NoosFormTypeService.register('dataset')
export class DatasetComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    setting: IHttpSetting;
    isFilter = false;

    itemData: IHttpReturnParam[] = [];
    thisAppearance: any = 'outline';

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    constructor(private httpService: HttpFormDataService, private eventListenerService: FormEventService) {
        this.setting = GlobalObjectService.getVar('setting');
    }

    ngOnInit() {
    }


    ngAfterViewInit(): void {

        if (this.isFilter) {
            this.prop.requared = false;
        }

        if (this.prop.options.multiple) {
            const multipleFieldDatasetId = this.prop.options.multiple_field_dataset_id;
            const multipleFieldName = this.prop.options.multiple_field_name;
            this.httpService.getDatasetParamsWMultiple(this.setting, multipleFieldDatasetId, multipleFieldName).subscribe(ret => {
                if (ret.complete) {
                    this.itemData = ret.data;
                }
            });
        } else {
            this.httpService.getDatasetParams(this.setting, this.prop.options.dataset_id).subscribe(ret => {
                if (ret.complete) {
                    this.itemData = ret.data;
                }
            });
        }

    }

    comparer(o1: any, o2: any): boolean {
        return o1 && o2 ? o1.toString() === o2.toString() : false;
    }

    onSelect(value: any) {
        this.eventListenerService.updatedDataSelection({
            fromComponentId: this.prop.id,
            fromComponentName: this.prop.name,
            eventName: this.prop.options.form_selector !== undefined && this.prop.options.form_selector ? 'set_form_id' : 'select',
            triggerValue: value,
            formId: this.formId,
            datasetId: this.datasetId
        });
    }
}
